import { useWebsiteBanner, WEBSITE_BANNER_PRIORITY } from '@shared/components/WebsiteBanner';
import { useTranslation } from '@shared/core';

interface UseUnpublishedWebsiteBannerArgs
  extends Readonly<{
    isVisible: boolean;
    onPublish: () => void;
    isPublishing: boolean;
    onClose?: () => void;
  }> {}

/**
 * Registers the unpublished website banner.
 * Shows when the website is hidden from guests.
 */
export const useUnpublishedWebsiteBanner = (args: UseUnpublishedWebsiteBannerArgs) => {
  const { isVisible, onPublish, isPublishing, onClose } = args;
  const { tq } = useTranslation('publishReminder');

  useWebsiteBanner({
    id: 'unpublished-website',
    priority: WEBSITE_BANNER_PRIORITY.unpublishedWebsite,
    isVisible,
    message: {
      default: tq`Your website is hidden from guests for now. Publish it when you're ready to share.`,
      mobile: tq`Your website is hidden from guests for now. Publish before sharing.`,
    },
    actionButton: {
      label: {
        default: tq`Publish Website`,
        mobile: tq`Publish`,
      },
      onClick: onPublish,
      loading: isPublishing,
    },
    onClose,
  });
};
